// extracted by mini-css-extract-plugin
export default {"root":"mobile-preview-shell_root__JBNBM","host":"mobile-preview-shell_host__UewQW","stage":"mobile-preview-shell_stage__UYiyu","viewport":"mobile-preview-shell_viewport__LOvWd"};